import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { FrameworksList } from "../components/detail/FrameworksList";
import BirdHeader from "../components/layout/BirdHeader";
import { FooterHomepage } from "../components/layout/BirdFooterHomepage";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

import "../scss/pages/_birdHomePage.scss";

import image from "../assets/ECNMC_ACTVTY.png";
import ForwardEngineering from "../assets/ForwardEngineering.png";
import DerivationArrow from "../assets/DerivationArrow.png";
import GenerationArrow from "../assets/GenerationArrow.png";

@inject("searchStore", "http", "navigatorStore")
@observer
export class NavigatorPage extends React.Component {
  componentDidMount() {
    const {
      setCurrentFrameworkListDisplayType,
      setFrameworkListLabel,
      getFrameworkListDisplayType,
      setFrameworkListLabelForBurgerMenu,
    } = this.props.navigatorStore;
    setCurrentFrameworkListDisplayType(getFrameworkListDisplayType.PUBLISHED);
    setFrameworkListLabel("Output reporting Frameworks (in BIRD)");
    setFrameworkListLabelForBurgerMenu("Frameworks (in BIRD)");
  }
  renderLink = (link, src, title, index) => {
    return (
      <Link to={link} className="link" key={`fp-${index}`}>
        <div className="link-img-aspect">
          <div className="link-img-container">
            {src ? (
              <img src={src.default ? src.default : src} alt={title} />
            ) : null}
          </div>
        </div>
        <h5>{title}</h5>
      </Link>
    );
  };
  renderLinks = (logicalLayerItems, physicalLayerItems) => {
    const styles = {
      globalLinksContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
      verticalTitles: {
        display: "flex",
        writingMode: "tb-rl",
        transform: `scale(-1, -1)`,
        alignItems: "center",
        justifyContent: "center",
        color: "#003299",
        fontSize: "18px",
        marginRight: "10px",
      },
      linksColumnContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
      },
      linksDataContainer: {
        display: "flex",
        border: "2px solid #003299",
        height: "150px",
        width: "150px",
        alignItems: "center",
        justifyContent: "center",
        color: "#003299",
        textAlign: "center",
        fontSize: "20px",
      },
      forwardEngineeringImage: {
        height: "auto",
        width: "70px",
        alignSelf: "center",
      },
      transformationsImage: {
        height: "50px",
        width: "100px",
        alignSelf: "center",
        marginBottom: "18%",
        marginRight: "10px",
      },
      transformationsImageBottom: {
        height: "50px",
        width: "100px",
        alignSelf: "center",
        marginRight: "10px",
      },
    };
    const generationTooltip = (
      <Tooltip id="tooltip">
        <strong>
          Description of the process to generate output reporting requirements.
          Additional information in the BIRD components section of About BIRD.
        </strong>
      </Tooltip>
    );
    const derivationTooltip = (
      <Tooltip id="tooltip">
        <strong>
          Description of the process to generate derived attributes based on the
          “raw” data. Additional information in the BIRD components section of
          About BIRD.
        </strong>
      </Tooltip>
    );
    const forwardTooltip = (
      <Tooltip id="tooltip">
        <strong>
          Description of the metadata lineage between the logical and physical
          layer. Additional information in the BIRD components section of About
          BIRD.
        </strong>
      </Tooltip>
    );

    return (
      <>
        <div style={styles.globalLinksContainer}>
          <div style={{ ...styles.verticalTitles, marginBottom: "70px" }}>
            Logical
          </div>
          {logicalLayerItems
            .slice(0, 6)
            .map(({ link, src, title, tooltip }, index) => {
              const redirectLink = this.figureOutLink(link);
              return (
                <React.Fragment key={`fp-${index}`}>
                  <div style={styles.linksColumnContainer}>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          <strong>{tooltip}</strong>
                        </Tooltip>
                      }
                      delayShow={300}
                      delayHide={150}
                    >
                      <a href={redirectLink}>
                        <div style={styles.linksDataContainer}>{title}</div>
                      </a>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={forwardTooltip}
                      delayShow={300}
                      delayHide={150}
                    >
                      <img
                        style={styles.forwardEngineeringImage}
                        src={ForwardEngineering}
                        alt={"ForwardEngineering"}
                      />
                    </OverlayTrigger>
                  </div>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      index === logicalLayerItems.length - 1
                        ? generationTooltip
                        : derivationTooltip
                    }
                    delayShow={300}
                    delayHide={150}
                  >
                    <img
                      style={styles.transformationsImage}
                      src={
                        index === logicalLayerItems.length - 1
                          ? GenerationArrow
                          : DerivationArrow
                      }
                      alt={"DerivationArrow"}
                    />
                  </OverlayTrigger>
                </React.Fragment>
              );
            })}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div style={styles.verticalTitles}>Physical</div>
          {physicalLayerItems
            .slice(0, 6)
            .map(({ link, src, title, tooltip }, index) => {
              const redirectLink = this.figureOutLink(link);
              return (
                <React.Fragment key={`fp-${index}`}>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip">
                        <strong>{tooltip}</strong>
                      </Tooltip>
                    }
                    delayShow={300}
                    delayHide={150}
                  >
                    <a href={redirectLink}>
                      <div style={styles.linksDataContainer}>{title}</div>
                    </a>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      index === logicalLayerItems.length - 1
                        ? generationTooltip
                        : derivationTooltip
                    }
                    delayShow={300}
                    delayHide={150}
                  >
                    <img
                      style={styles.transformationsImageBottom}
                      src={
                        index === logicalLayerItems.length - 1
                          ? GenerationArrow
                          : DerivationArrow
                      }
                      alt={"DerivationArrow"}
                    />
                  </OverlayTrigger>
                </React.Fragment>
              );
            })}
        </div>
      </>
    );
  };

  figureOutLink = (shouldRedirectTo) => {
    return !!shouldRedirectTo && shouldRedirectTo !== "/"
      ? shouldRedirectTo
      : window.location;
  };

  render() {
    const { filtersVisible } = this.props.searchStore;
    /**
     * @todo Use the method from HomePage.js to load cube hierarchies once they exist in BIRD
     */
    const logicalLayerItems = [
      {
        title: "Logical Data Model",
        src: image,
        link: "bycode/cube_hierarchy/ECB/BIRD_LDM_HIERARCHY",
        tooltip:
          "Highly normalised and detailed logical model providing a complete description of all the necessary business requirements, helping users understand them for reporting purposes. Additional information in the BIRD components section of About BIRD.",
      },
      {
        title: "Enriched Logical Data Model",
        src: image,
        link: "bycode/cube_hierarchy/ECB/BIRD_ELDM_HIERARCHY",
        tooltip:
          "Extension of the BIRD LDM including all the attributes (variables) derived via Derivation Transformation Rules. Additional information in the BIRD components section of About BIRD.",
      },
    ];
    const physicalLayerItems = [
      {
        title: "Input Layer",
        src: image,
        link: "/bycode/cube_hierarchy/ECB/BIRD_IL_HIERARCHY",
        tooltip:
          "Example of a simplified model that contains fewer business requirements, but is easier to browse.  Additional information in the BIRD components section of About BIRD.",
      },
      {
        title: "Enriched Input Layer",
        src: image,
        link: "/bycode/cube_hierarchy/ECB/BIRD_EIL_HIERARCHY",
        tooltip:
          "Extension of the BIRD IL including all the attributes (variables) derived via Derivation Transformation Rules. Additional information in the BIRD components section of About BIRD.",
      },
    ];
    const styles = {
      LinkStyle: {
        fontSize: "16px",
        color: "#003299",
      },
      FilterVisible: {
        marginTop: "-50px",
      },
    };

    return (
      <div style={filtersVisible ? styles.FilterVisible : null}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "50px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "26px",
                color: "#003299",
                marginLeft: "20px",
                fontWeight: "bold",
              }}
            >
              Navigator
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                maxWidth: "400px",
                marginRight: "20px",
              }}
            >
              <a style={styles.LinkStyle} href="/userguide/index.html">
                Tutorials
              </a>
              {/* <Link style={styles.LinkStyle} to="/frameworksNotYetInBird">
                Frameworks not yet in BIRD
              </Link> */}
            </div>
          </div>
          <BirdHeader></BirdHeader>
          <div>
            <div className="home-page BirdHomePage">
              <div className="dashboard-container">
                <div className="link-groups-container">
                  <div
                    style={{
                      display: "flex",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      padding: "10px",
                      width: "54%",
                      marginRight: "20px",
                      flexDirection: "column",
                    }}
                    // className="link-group"
                  >
                    <div className="descriptive-metadata custom-panel">
                      <div className="custom-panel-heading reference">
                        <h4>Input</h4>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        overflowX: "scroll",
                        padding: "0 10px",
                        alignItems: "center",
                      }}
                    >
                      {this.renderLinks(logicalLayerItems, physicalLayerItems)}
                    </div>
                  </div>
                  <FrameworksList isHomePage={true} isBurgerMenu={false} />
                </div>
              </div>
            </div>
          </div>
          <FooterHomepage></FooterHomepage>
        </div>
      </div>
    );
  }
}
